import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function Testimonials() {
  return <section className="bg-navy px-5 py-16 md:py-24" data-id="element-294" data-mp="3mfhhs90jy3ju">
      <div className="mx-auto max-w-5xl" data-id="element-295" data-mp="3r7sgj8jk3jat">
        <SectionHeading dark eyebrow="What professionals are looking for" title={<>
              Not another library of information. <em className="italic text-gold" data-id="element-297" data-mp="41rs37wug77b">A better way to use it.</em>
            </>} data-id="element-296" data-mp="3r8ttxjo1ohvp" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-298" data-mp="937astbju1mj">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-299" data-mp="dzo0hryeco1q">
              <div className="flex items-center gap-4" data-id="element-300" data-mp="2au2bnzkm4r04">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-gold" data-id="element-301" data-mp="2avlqdlqmetzs" />
                <div className="min-w-0" data-id="element-302" data-mp="1smlzzctk1mxl">
                  <p className="font-bold text-navy" data-id="element-303" data-mp="1ntkjx1hm3hcf">{t.name}</p>
                  <p className="text-sm text-navy/60" data-id="element-304" data-mp="1nrzsvluiagjb">{t.role}</p>
                  <div className="mt-1 flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-305" data-mp="1iv98wnfkz0sm">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-306" data-mp="2bjx0t1uu4of5" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <p className="mt-5 flex gap-2 font-serif text-2xl font-black leading-tight text-navy" data-id="element-307" data-mp="22ip2wkw8dpll">
                <QuoteIcon className="mt-1 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-308" data-mp="1xjm6tpy8atpr" />
                {t.quote}
              </p>
              <p className="mt-auto border-t border-navy/10 pt-4 text-[15px] leading-relaxed text-navy/75" data-id="element-309" data-mp="r4bjptcf9ybw">
                <span className="font-bold text-cta" data-id="element-310" data-mp="m2vxvz2f7nsg">→ </span>
                {t.answer}
              </p>
            </li>)}
        </ul>

        <SectionCta label="I want a system I can actually use" data-id="element-311" data-mp="skpg0y3ohrlp" />
      </div>
    </section>;
}